var map = {
	"./AlbbPublishProduct/components/albbFormItem.vue": "./src/componentBase/AlbbPublishProduct/components/albbFormItem.vue",
	"./AlbbPublishProduct/components/checkboxAndRadio.vue": "./src/componentBase/AlbbPublishProduct/components/checkboxAndRadio.vue",
	"./AlbbPublishProduct/components/colorSelect.vue": "./src/componentBase/AlbbPublishProduct/components/colorSelect.vue",
	"./AlbbPublishProduct/components/deliveryService.vue": "./src/componentBase/AlbbPublishProduct/components/deliveryService.vue",
	"./AlbbPublishProduct/components/freightSelect.vue": "./src/componentBase/AlbbPublishProduct/components/freightSelect.vue",
	"./AlbbPublishProduct/components/inputTag.vue": "./src/componentBase/AlbbPublishProduct/components/inputTag.vue",
	"./AlbbPublishProduct/components/photoAlbum.vue": "./src/componentBase/AlbbPublishProduct/components/photoAlbum.vue",
	"./AlbbPublishProduct/components/productPriceRange.vue": "./src/componentBase/AlbbPublishProduct/components/productPriceRange.vue",
	"./AlbbPublishProduct/components/productPriceSku.vue": "./src/componentBase/AlbbPublishProduct/components/productPriceSku.vue",
	"./AlbbPublishProduct/components/productWeightSku.vue": "./src/componentBase/AlbbPublishProduct/components/productWeightSku.vue",
	"./AlbbPublishProduct/index.vue": "./src/componentBase/AlbbPublishProduct/index.vue",
	"./BaseCategory/index.vue": "./src/componentBase/BaseCategory/index.vue",
	"./BaseCode/index.vue": "./src/componentBase/BaseCode/index.vue",
	"./BaseDetailQrcode/index.vue": "./src/componentBase/BaseDetailQrcode/index.vue",
	"./BaseExtendFields/index.vue": "./src/componentBase/BaseExtendFields/index.vue",
	"./BaseFurnitureStock/index.vue": "./src/componentBase/BaseFurnitureStock/index.vue",
	"./BaseImageTag/index.vue": "./src/componentBase/BaseImageTag/index.vue",
	"./BaseLastSellInfo/index.vue": "./src/componentBase/BaseLastSellInfo/index.vue",
	"./BaseNumInput/index.vue": "./src/componentBase/BaseNumInput/index.vue",
	"./BaseOemGoogleSearch/index.vue": "./src/componentBase/BaseOemGoogleSearch/index.vue",
	"./BaseOemSearch/index.vue": "./src/componentBase/BaseOemSearch/index.vue",
	"./BasePrice/index.vue": "./src/componentBase/BasePrice/index.vue",
	"./BasePriceInput/index.vue": "./src/componentBase/BasePriceInput/index.vue",
	"./BaseProductChannel/index.vue": "./src/componentBase/BaseProductChannel/index.vue",
	"./BaseProductStatusTag/index.vue": "./src/componentBase/BaseProductStatusTag/index.vue",
	"./BaseRichText/index.vue": "./src/componentBase/BaseRichText/index.vue",
	"./BaseSingleSpecs/index.vue": "./src/componentBase/BaseSingleSpecs/index.vue",
	"./BaseSku/index.vue": "./src/componentBase/BaseSku/index.vue",
	"./BaseSpecs/index.vue": "./src/componentBase/BaseSpecs/index.vue",
	"./BaseSpecsBox/index.vue": "./src/componentBase/BaseSpecsBox/index.vue",
	"./BaseStock/index.vue": "./src/componentBase/BaseStock/index.vue",
	"./BaseSuppliers/index.vue": "./src/componentBase/BaseSuppliers/index.vue",
	"./BaseTitleTags/index.vue": "./src/componentBase/BaseTitleTags/index.vue",
	"./BaseVehicles/index.vue": "./src/componentBase/BaseVehicles/index.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/componentBase sync recursive \\.vue$";